import type { IBreadcrumbs } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { activationTracking } from "app/pages/activation/services/tracking";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const onCrumbClick: IBreadcrumbs["onClick"] = ({ title, state, params }) => {
    const track = activationTracking.home;
    const apiParams = proNavigator.getApiParams();

    track.trackUserClickOnBreadcrumbs(translate(title));

    void proNavigator.go(state, { ...apiParams, ...params });
};
